export default "__VITE_ASSET__Be6Q3ye9__"